export const localizeDate = (date: Date): string =>
  new Intl.DateTimeFormat(navigator.language, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).format(date);
